import {AccessOption} from '../../../util/permissions';

export const RESTRICTED_PROJECT_REASON =
  'Restricted projects can only be changed to Team visibility.';
export const TEAM_SETTINGS_REASON =
  "Unavailable due to your team's privacy settings.";
export const ORG_SETTINGS_REASON =
  "Unavailable due to your organization's privacy settings.";

export interface BlockedPublicAccessInput {
  isPersonalEntity: boolean;
  currentProjectAccess: AccessOption | null;
  teamPrivateOnly: boolean;
  teamHidden: boolean;
  orgPrivateOnly: boolean;
  orgHidden: boolean;
}

/**
 * Explains why Public and Open cannot be selected for a project, or returns
 * null when they can. Only the team flags block; org enforcement copies its
 * flag onto every team, so the org flags only decide whether a blocking team
 * flag is attributed to the org.
 */
export function getBlockedPublicAccessReason({
  isPersonalEntity,
  currentProjectAccess,
  teamPrivateOnly,
  teamHidden,
  orgPrivateOnly,
  orgHidden,
}: BlockedPublicAccessInput): string | null {
  if (currentProjectAccess === AccessOption.Restricted) {
    return RESTRICTED_PROJECT_REASON;
  }
  if (isPersonalEntity) {
    return null;
  }
  if ((teamPrivateOnly && orgPrivateOnly) || (teamHidden && orgHidden)) {
    return ORG_SETTINGS_REASON;
  }
  if (teamPrivateOnly || teamHidden) {
    return TEAM_SETTINGS_REASON;
  }
  return null;
}
